import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { bluebookQueryKeys } from '@p/a/client-report/hooks/queries/query-keys';

import { IResult } from '@t/api';
import { BluebookParameters } from '@t/api/bluebook/bluebook-dashboard-parameters.model';
import { IBluebookClient } from '@t/api/client-list/bluebook-client.model';

import { returnServices } from 'services/returns.service';

export const createBluebookDashboardQuery = (
  parameters?: BluebookParameters
): UseQueryOptions<IResult<IBluebookClient[]> | undefined, unknown, IBluebookClient[] | undefined> => {
  return {
    placeholderData: keepPreviousData,
    queryFn: async () => await returnServices.getReturnClients(parameters),
    queryKey: bluebookQueryKeys.clients.filteredClients(parameters),
  };
};

export const useFetchBluebookClients = (parameters?: BluebookParameters) => {
  return useQuery(createBluebookDashboardQuery(parameters));
};
